import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Columns } from 'views/Grid';

const LinksPostPurchaseMerchantHeader = ({
  sellerAvatar, fullName,
}) => (
  <div className={classNames('payments-header', sellerAvatar ? 'has--avatar' : null)}>
    <div className="soft" style={{ background: '#F3F6FA', borderRadius: '4px 4px 0 0' }}>
      <Row className="collapse">
        <Columns className="small-2">
          <img
            className="payments-header--avatar"
            height={40} width={40}
            alt={fullName}
            src={sellerAvatar}
            />
        </Columns>
        <Columns className="small-10">
           <p className="flush--bottom break-long-words soft-half--top">{fullName}</p>
        </Columns>
      </Row>
    </div>
  </div>
);

LinksPostPurchaseMerchantHeader.propTypes = {
  sellerAvatar: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
};

export default LinksPostPurchaseMerchantHeader;



// WEBPACK FOOTER //
// ./src/payments/views/links/LinksPostPurchaseMerchantHeader.js